import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'lgb-radial-progress',
  standalone: false,
  templateUrl: './radial-progress.html',
  styleUrl: './radial-progress.css',
})
export class RadialProgress {
  readonly _tx=input.required<number>({alias: 'tx'});
  readonly tx=computed(() => Number(this._tx().toFixed(2)));
}
